export enum AuditType {
  PRODUCE = "Продукция",
  MATERIAL = "Материал",
  CLIENT = "Клиент",
}

export enum AuditStatus {
  PENDING = "Не завершён",
  COMPLETED = "Завершён",
}

export interface IAudit {
  _id: string;
  type: AuditType;
  status: AuditStatus;
  description: string;
  endDate?: string;
  startDate: string;
  ownerId: string;
  ownerName: string;
  difference: {
    USD: number;
    TJS: number;
  };
  amountBefore: {
    USD: number;
    TJS: number;
  };
  amountAfter: {
    USD: number;
    TJS: number;
  };
}
